<template>
  <empty-section
    description="Пов'язані завдання будуть показані тут"
    title="Зв'язків ще немає" />
</template>

<script lang="ts">
import EmptySection from '@/components/EmptySection.vue'

export default {
  name: 'TaskLinksTab',
  components: { EmptySection },
}
</script>
